import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    accounts: {
        defaultMessage: 'Accounts',
        id: 'iaso.label.accounts',
    },
    name: {
        defaultMessage: 'Name',
        id: 'iaso.label.name',
    },
    created_at: {
        id: 'iaso.account.created_at',
        defaultMessage: 'Creation date',
    },
    actions: {
        defaultMessage: 'Action(s)',
        id: 'iaso.label.actions',
    },
    view: {
        defaultMessage: 'View',
        id: 'iaso.label.view',
    },
    editAIApiKey: {
        defaultMessage: 'Edit AI API key',
        id: 'iaso.label.editAIApiKey',
    },
    aiApiKeyLabel: {
        defaultMessage: 'AI API key',
        id: 'iaso.label.aiApiKey',
    },
    cancel: {
        id: 'iaso.label.cancel',
        defaultMessage: 'Cancel',
    },
    save: {
        id: 'iaso.label.save',
        defaultMessage: 'Save',
    },
    featureFlagsTitle: {
        id: 'iaso.accounts.title.featureFlagsTitle',
        defaultMessage: 'Feature flags',
    },
    modulesTitle: {
        id: 'iaso.accounts.title.modulesTitle',
        defaultMessage: 'Modules',
    },
    generalInfoTitle: {
        id: 'iaso.accounts.title.generalInfoTitle',
        defaultMessage: 'Information',
    },
    deleteAIApiKey: {
        id: 'iaso.accounts.title.deleteAIApiKey',
        defaultMessage: 'Delete AI API key',
    },
    editAccount: {
        id: 'iaso.accounts.title.editAccount',
        defaultMessage: 'Edit account',
    },
    userManualPath: {
        id: 'iaso.accounts.label.userManualPath',
        defaultMessage: 'User manual address',
    },
    forumPath: {
        id: 'iaso.accounts.label.forumPath',
        defaultMessage: 'Forum address',
    },
    forceStrongPassword: {
        id: 'iaso.accounts.label.forceStrongPassword',
        defaultMessage: 'Force strong password',
    },
    status: {
        defaultMessage: 'Status',
        id: 'iaso.accounts.label.status',
    },
    selected: {
        defaultMessage: 'Selected',
        id: 'iaso.accounts.selected',
    },
    notSelected: {
        defaultMessage: 'Not selected',
        id: 'iaso.accounts.notSelected',
    },
    anthropicAPIKey: {
        defaultMessage: 'Anthropic API key',
        id: 'iaso.accounts.label.anthropicAPIKey',
    },
    yes: {
        defaultMessage: 'Yes',
        id: 'iaso.label.yes',
    },
    no: {
        defaultMessage: 'No',
        id: 'iaso.label.no',
    },
    formAIModuleTooltipTitle: {
        defaultMessage: 'Make sure to provide an AI API key',
        id: 'iaso.modules.formAI.tooltip.title',
    },
    edit: {
        defaultMessage: 'Edit',
        id: 'iaso.label.edit',
    },
    accountTabs: {
        defaultMessage: 'Account tabs',
        id: 'iaso.accounts.accountTabs.ariaLabel',
    },
    accountTabGeneralTitle: {
        defaultMessage: 'General',
        id: 'iaso.accounts.accountTabs.general.title',
    },
    noResultsFound: {
        defaultMessage: 'No results found.',
        id: 'iaso.accounts.noResultsFound',
    },
    additionalInfo: {
        defaultMessage: 'Additional information',
        id: 'iaso.accounts.table.header.additionInformation',
    },
});

export default MESSAGES;
